import * as ActionTypes from "./ActionTypes";

export const SetInitialSet = setInfo => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_LIVE_INITIAL_SET,
    setInfo: setInfo
  };
};

export const SetThirdPartitionedSet = setInfo => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_LIVE_THIRD_PARTITION_SET,
    setInfo: setInfo
  };
};

export const SetPrematchPickerInfo = pickerInfo => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_PREMATCH_PICKER_ITEMS,
    pickerInfo: pickerInfo
  };
};

export const SetPrematchLeaguesInfo = leagueInfo => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_PREMATCH_LEAGUE_INFO,
    leagueInfo: leagueInfo
  };
};

export const SetPrematchCategoriesInfo = categories => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_PREMATCH_CATEGORIES_INFO,
    categories: categories
  };
};

export const SetAllBetsText = allBetsText => {
  return {
    type: ActionTypes.SPORT_EVENT_SET_ALL_BETS_TEXT,
    allBetsText: allBetsText
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/SportEventActions.js